"use client";

import { getPopularProductsList } from "@/modules/products/actions/products";
import { HttpTypes } from "@medusajs/types";
import { useQuery } from "@tanstack/react-query";
import { useLocationStore } from "@/store/index";

interface UsePopularProductsParams {
  countryCode?: string;
  regionId?: string;
  currencyCode?: string;
  queryParams?: HttpTypes.StoreProductListParams;
}

export const usePopularProducts = ({
  countryCode,
  regionId,
  currencyCode,
  queryParams,
}: UsePopularProductsParams) => {
  const { province, municipality } = useLocationStore();

  return useQuery({
    queryKey: ["popular-products", countryCode, regionId, currencyCode, queryParams, province, municipality],
    queryFn: async () => {
      const { response } = await getPopularProductsList({
        countryCode,
        regionId,
        currency_code: currencyCode,
        queryParams,
        province: province || undefined,
        municipality: municipality || undefined,
      });
      return response;
    },
    enabled: !!(countryCode || regionId),
  });
};
